import * as React from "react";
import { action } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import LegalStore from "../../../stores/legalStore";
import { ILocalization } from "../../../models/localization";
import { BusyEvent } from "../../../models/enums";
import Busy from "../../widgets/busy";
import { Row, Col, Grid } from "react-flexbox-grid";
import OpportunitySummaryCard from "../opSummary";
import { OpportunitySummary } from "../../../models/opportunity";
import * as s from "./recommendedOps.css";

@observer
export default class RecommendedOps extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  renderOps(): JSX.Element {
      let cards: JSX.Element[] = [];
      this.props.store.opportunityStore.recommendedOps.map((os: OpportunitySummary, i: number): void => {
          cards.push(<OpportunitySummaryCard key={i} store={this.props.store} op={os} />);
      });
      return <Grid className={s.grid} fluid><Row>{cards}</Row></Grid>
  }
  render(): JSX.Element {
    if (this.props.store.opportunityStore.recommendedOps.length === 0) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;
    return (<div className={s.container}>
      <Row>
        <Col xs={12}>
          <h4 className={s.featureTitle}>{local.recommendedOps}</h4>
          <p className={s.blueHeader}>{local.recommendedSubHeader}</p>
        </Col>
      </Row>
      {this.props.store.viewState.isBusy(BusyEvent.LoadCourses) && <Busy show={true} size="sm" />}
      {this.renderOps()}
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/recommendedOps/index.tsx